import type { customComponent } from 'src/core/ui/PageHeader';

export function separateMenuComponents(components: (customComponent & { position?: string })[]) {
  let OtherComponents = [];
  let MenuItemsComponents = [];
  let CenterComponents = [];
  components?.forEach(function(customComponent) {
    if (customComponent.position === "center") {
      CenterComponents.push(customComponent);
    } else if (customComponent.isInGroupedMenu) {
      MenuItemsComponents.push(customComponent);
    } else {
      OtherComponents.push(customComponent);
    }
  });
  return [OtherComponents, MenuItemsComponents, CenterComponents];
}
